import React from 'react'
import classNames from 'classnames'
import {useTranslation} from '@wix/yoshi-flow-editor'
import {DH} from '../../../constants/data-hooks'
import {getMoreOccurrencesCount, isLastAvailableOccurrence} from '../../../selectors/occurrences'
import cs from '../../classnames.scss'
import {usePageState} from '../../runtime-context/context'
import s from './recurring-dates-count.scss'

export const RecurringDatesCount = () => {
  const count = usePageState(getMoreOccurrencesCount)
  const isLastOccurrence = usePageState(isLastAvailableOccurrence)
  const {t} = useTranslation()

  return (
    <div data-hook={DH.eventDetailsFullLocation} className={classNames(s.root, cs.evTextFont, cs.evTextColor)}>
      {isLastOccurrence ? t('recurring.lastAvailableDate') : t('recurring.moreDatesLabel', {count})}
    </div>
  )
}
